import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './hooks/useAuth'; 
import './i18n'; // Importando a configuração i18n

// ============================================================
// SECURITY: Suppress all console output in production builds.
// This prevents leaking internal state, API responses, user data,
// and stack traces to anyone with browser DevTools open.
// ============================================================
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  (console as any).log   = noop;
  (console as any).info  = noop;
  (console as any).debug = noop;
  (console as any).warn  = noop;
  (console as any).error = noop;
  (console as any).table = noop;
  (console as any).group = noop;
  (console as any).groupEnd = noop;
  (console as any).groupCollapsed = noop;
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);